module.exports = __webpack_public_path__ + "static/img/学生信息.98d55bec.png";